import React from "react";
import { formatTime, groupByDay } from "@/lib/dates";

export interface LogLine {
  key: string | number;
  mark: React.ReactNode;
  body: React.ReactNode;
}

/// A log's rows under day headings, each with its mark and time.
export function LogDays<E>({
  entries,
  at,
  line,
}: {
  entries: E[];
  at: (entry: E) => string;
  line: (entry: E) => LogLine;
}) {
  return (
    <div className="flex flex-col">
      {groupByDay(entries, at).map((day) => (
        <div key={day.key} className="flex flex-col">
          {/* Sticky so a long scroll never leaves a time without its day. */}
          <span className="sticky top-0 z-10 bg-bg px-2 pt-3 pb-1 text-fg-muted-regular-small">
            {day.label}
          </span>
          {day.items.map((entry) => {
            const { key, mark, body } = line(entry);
            return (
              <div
                key={key}
                className="flex items-baseline gap-2 rounded-app px-2 py-1 hover:bg-list-hover"
              >
                <span
                  aria-hidden
                  className="flex w-3.5 shrink-0 justify-center self-start pt-0.5"
                >
                  {mark}
                </span>
                <span
                  className="w-8 shrink-0 self-start font-mono tabular-nums text-fg-muted"
                  style={{ fontSize: "var(--font-size-x-small)" }}
                >
                  {formatTime(at(entry))}
                </span>
                <span className="min-w-0 text-fg-muted-regular-small">
                  {body}
                </span>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
